import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule,PreloadAllModules} from '@angular/router';
import {ReportingComponent} from '../reporting/components/reporting.component';
import {ReportingService} from '../reporting/services/reporting.service'
import {RoleGuardService} from '../../role-guard.service';
import {NgxPaginationModule} from 'ngx-pagination';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
const routes: Routes = [
  {path: 'reporting', component: ReportingComponent,canActivate :[RoleGuardService]},
];


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    NgMultiSelectDropDownModule,
    RouterModule.forRoot(routes,
      {
        useHash: false,
        preloadingStrategy: PreloadAllModules
      }),
  ],
  exports: [RouterModule],
  providers:[ReportingService],
  declarations: [ReportingComponent]
})

export class ReportingModule {}



// WEBPACK FOOTER //
// ./src/app/modules/reporting/reporting.module.ts